<p-progressSpinner styleClass="custom-spinner" [style]="{width: size + 'px', height: size + 'px', 'z-index': 10000}"></p-progressSpinner>
<div *ngIf="backdrop" class="backdrop" [style.opacity.%]="opacity" [style.background-color]="backgroundColor"></div>
